<div
    packboImageLoading
    (allImagesLoaded)="onAllImagesLoaded($event)"
    class="3xl:grid-cols-4 grid w-full grid-cols-1 gap-x-4 gap-y-3 overflow-hidden sm:gap-y-6 lg:grid-cols-2 2xl:grid-cols-3"
>
    @for (supplier of suppliers(); track supplier.id) {
        @let supplierPackage = supplier | sanitizeSupplierPackage;
        @let supplierCoord = supplier | sanitizeSupplierCoord;
        @let category = supplier | getCategory;
        @let imageData = supplier | supplierImageData: category;

        @if (supplierPackage?.is_showcase_membership) {
            <a
                class="col-span-full hidden w-full cursor-pointer flex-col overflow-hidden lg:flex"
                [href]="supplier | pathFromItem: 'supplier'"
            >
                @if (supplier.is_eco_friendly) {
                    <div class="absolute z-1 -m-2 place-self-end">
                        <svg-icon
                            src="assets/icons/Eco-Responsible.svg"
                            [svgStyle]="{ width: '48px', height: '48px' }"
                        />
                    </div>
                }
                <div class="flex items-end justify-start">
                    @if (supplier.banner) {
                        <figure class="border-neutral-variant-40/20 rounded-lg border">
                            <img
                                [ngSrc]="supplier.banner | getDirectusImage"
                                [alt]="supplier.name"
                                width="3000"
                                height="1000"
                                priority
                                class="aspect-3/1 max-w-full min-w-full rounded-lg object-fill"
                            />
                        </figure>
                    } @else {
                        <div
                            class="border-neutral-variant-40/20 bg-neutral-80 aspect-3/1 w-full rounded-lg border"
                        ></div>
                    }
                    <div class="absolute z-1 mb-3 ml-3 rounded-lg bg-white/75 p-6 backdrop-blur-xl">
                        <div class="flex items-center gap-3">
                            <span class="text-title-medium text-center">
                                {{ supplier.name }}
                            </span>
                            <div class="flex justify-center gap-2">
                                @if (supplierCoord) {
                                    <span class="text-label-large">{{ supplierCoord.locality }}</span>
                                    <ng-container
                                        *ngTemplateOutlet="distanceDisplay; context: { supplier: supplier }"
                                    />
                                }
                            </div>
                            <packbo-package-badge
                                [package]="supplierPackage"
                                [prefix]="'supplier.member' | transloco"
                            />
                        </div>
                    </div>
                </div>
            </a>

            <a
                class="border-neutral-variant-40/20 relative grid w-full max-w-90 grid-cols-1 items-center justify-items-center overflow-hidden rounded-lg border bg-white lg:hidden"
                [href]="supplier | pathFromItem: 'supplier'"
            >
                @if (supplier.is_eco_friendly) {
                    <div
                        class="absolute top-1 right-1 z-1 lg:top-auto lg:right-auto lg:-m-2 lg:self-start lg:justify-self-end"
                    >
                        <svg-icon
                            src="assets/icons/Eco-Responsible.svg"
                            [svgStyle]="{ width: '48px', height: '48px' }"
                        />
                    </div>
                }
                @if (supplier.banner) {
                    <figure>
                        <img
                            [ngSrc]="supplier.banner | getDirectusImage"
                            [alt]="supplier.name"
                            width="360"
                            height="360"
                            priority
                            class="h-full max-h-90 w-full max-w-90 object-cover"
                        />
                    </figure>
                } @else {
                    <div class="h-full max-h-90 w-full max-w-90 rounded-lg"></div>
                }
                <div class="flex flex-col items-center justify-center gap-4 p-6">
                    <div class="flex flex-col gap-2">
                        <packbo-package-badge [package]="supplierPackage" [prefix]="'supplier.member' | transloco" />
                        <figcaption class="text-title-medium text-center">
                            {{ supplier.name }}
                        </figcaption>
                        <div class="flex justify-center gap-2">
                            @if (supplierCoord) {
                                <span class="text-label-large">{{ supplierCoord.locality }}</span>
                                <ng-container *ngTemplateOutlet="distanceDisplay; context: { supplier: supplier }" />
                            }
                        </div>
                    </div>
                </div>
            </a>
        }

        @if (!supplierPackage?.is_showcase_membership) {
            <a
                class="border-neutral-variant-40/20 relative grid h-full max-h-87.5 min-h-87.5 w-full max-w-90 grid-cols-1 items-center justify-items-center overflow-hidden rounded-lg border bg-white lg:max-h-91 lg:min-h-91 lg:max-w-87 lg:min-w-87"
                [href]="supplier | pathFromItem: 'supplier'"
            >
                @if (supplier.is_eco_friendly) {
                    <div
                        class="absolute top-2 right-2 z-1 lg:top-auto lg:right-auto lg:-m-2 lg:self-start lg:justify-self-end"
                    >
                        <svg-icon
                            src="assets/icons/Eco-Responsible.svg"
                            [svgStyle]="{ width: '48px', height: '48px' }"
                        />
                    </div>
                }
                <div class="flex h-full flex-col items-center justify-center gap-4 p-6">
                    @if (
                        supplierPackage?.is_showcase_membership === null &&
                        supplierPackage?.hide_supplier_package === null
                    ) {
                        @if (imageData) {
                            <img
                                draggable="false"
                                width="300"
                                height="150"
                                class="max-h-37.5 min-h-37.5 max-w-75.5 min-w-75.5 place-self-center object-contain"
                                [ngSrc]="imageData.src | getDirectusImage"
                                [alt]="imageData.alt"
                                priority
                            />
                        }
                    } @else {
                        @if (category?.image) {
                            <img
                                draggable="false"
                                width="300"
                                height="150"
                                class="max-h-37.5 min-h-37.5 max-w-75.5 min-w-75.5 place-self-center object-contain"
                                [ngSrc]="category?.image | getDirectusImage"
                                [alt]="category?.translations_refs | getTranslation: 'title'"
                                priority
                            />
                        }
                    }
                    <div class="flex flex-col gap-2">
                        @if (
                            supplierPackage?.is_showcase_membership === null &&
                            supplierPackage?.hide_supplier_package === null
                        ) {
                            <packbo-package-badge
                                [package]="supplierPackage"
                                [prefix]="'supplier.member' | transloco"
                            />
                        }
                        <figcaption class="text-title-medium text-center">
                            {{ supplier.name }}
                        </figcaption>
                        <div class="flex justify-center gap-2">
                            @if (supplierCoord) {
                                <span class="text-label-large">{{ supplierCoord.locality }}</span>
                                <ng-container *ngTemplateOutlet="distanceDisplay; context: { supplier: supplier }" />
                            }
                        </div>
                    </div>
                </div>
            </a>
        }
    }
</div>

<ng-template #distanceDisplay let-supplier="supplier">
    @let roundedDistance = supplier | calculateDistance: userLocation();
    @if (roundedDistance | isDefined) {
        <div class="border-neutral-variant-40/20 flex items-center gap-2 border-l pl-2">
            <svg-icon
                src="assets/icons/Trip-Destination.svg"
                [svgStyle]="{ width: '16px', height: '16px' }"
                class="text-neutral-variant-20/50"
            />
            @if (roundedDistance === 0) {
                <span class="text-label-large">{{ "supplier_card.very_close" | transloco }}</span>
            } @else {
                <span class="text-label-large">{{ roundedDistance }} km</span>
            }
        </div>
    }
</ng-template>
